import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { ResourceGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";

const dummyResources = [
  {
    id: 1,
    title: "Ultra-Poor Graduation Programme Highlights 2023",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
  },
  {
    id: 2,
    title: "Graduation Overview",
    pdfUrl: "https://www.orimi.com/pdf-test.pdf",
  },
  {
    id: 3,
    title:
      "Policy Research on Climate Vulnerable Indigenous and Non-indigenous Poor Population Living in the Barind Tract of Bangladesh",
    pdfUrl: "https://gahp.net/wp-content/uploads/2017/09/sample.pdf",
  },
];

export default function ResourcesSection() {

      const [AllResources,setAllResources]=useState(dummyResources)
  
      const { request: getAllResources, data:resourcesData, error:resorcesError,isLoading:getResourceLoading} = useApi(ResourceGet);
          
      useEffect(() => {
        getAllResources();
              // eslint-disable-next-line
        }, []);
        
        useEffect(()=>{
          if (resourcesData?.status===200) {
            setAllResources(resourcesData?.data?.results);
          }
        // eslint-disable-next-line
        },[resourcesData])
      
        useEffect(()=>{
            if(resorcesError){
                toast.error(`${JSON.stringify(resorcesError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[resorcesError])


  const carouselRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const progress = (carousel.scrollLeft / maxScroll) * 100;
      setScrollProgress(progress);
    }
  };

  const scrollNext = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.scrollBy({ left: 350, behavior: "smooth" });
    }
  };

  const scrollPrev = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.scrollBy({ left: -350, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener("scroll", handleScroll);
      return () => carousel.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (<section className="news-news-carousel">
      {/* <h2 className="section-title">Our Stories and Articles</h2> */}
       <div className="news-carousel-container" ref={carouselRef}>
         <div className="news-carousel-news">
        {AllResources?.map((resource) => (
          <div className="news-news-card" key={resource.id} >
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "none",
                boxShadow: "none",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                },
              }}
            >
              {/* PDF Preview via Google Viewer */}
              <Box
                sx={{
                  width: "100%",
                  height: 420,
                  border: "1px solid #ddd",
                  mb: 2,
                }}
              >
                <iframe
                  src={`${resource.file_path}#toolbar=0&navpanes=0&scrollbar=0`}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                  title={resource.title}
                />
              </Box>

              <CardContent sx={{ textAlign: "center", mt: 1 }}>
              <Typography
                variant="subtitle1"
                component={Link}                    // make Typography behave like a link
                to={`/resource/detail/${resource?.id}/`}              // your target route
                state={{ resourceID: resource.id }} // pass ID via state
                sx={{
                  fontWeight: 600,
                  color: "#000",
                  mb: 1,
                  lineHeight: 1.4,
                  textDecoration: "none",           // remove underline
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {resource.title}
              </Typography>

                {/* Small underline */}
                <Divider
                  sx={{
                    width: "40px",
                    height: "3px",
                    backgroundColor: "#e5007d",
                    mx: "auto",
                  }}
                />
              </CardContent>
            </Card>
          </div>
        ))}
        </div>
        </div>
            {/* Carousel Controls */}
       <div className="news-carousel-controls">
         <button className="news-control-btn" onClick={scrollPrev}>
           ◀ 
         </button>

         <button className="news-control-btn" onClick={scrollNext}>
           ▶
         </button>
         <div className="news-progress-bar">
           <div
            className="news-progress-fill"
            style={{ width: `${scrollProgress}%` }}
           ></div>
       </div>
     </div>
     </section>
  )
}



// import React, { useEffect, useRef, useState } from 'react'
// import Slider from "react-slick";
// import { ArticleGet } from '../../api/orgService';
// import { toast } from 'react-toastify';
// import useApi from '../../api/useApi';

// function ArticleStoriesSection() {
//   const { request: getAllArticles, data:articleData, error:articleError} = useApi(ArticleGet);
    
//   useEffect(() => {
//     getAllArticles();
//          // eslint-disable-next-line
//     }, []);
    
//     useEffect(()=>{
//       if (articleData?.status===200) {
//         // setAllArticles(articleData?.data);
//       }
//     // eslint-disable-next-line
//     },[articleData])

  
//     // useEffect(()=>{
//     //     if(location?.state?.refresh==="org"){
//     //       getAllArticles();
//     //     }
//     //   // eslint-disable-next-line
//     //   },[location?.state])
  
//     useEffect(()=>{
//         if(articleError){
//             toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
//       }
//     },[articleError]) 

//     const newsItems = [
//         {
//           image: "https://picsum.photos/400/250?random=1",
//           icon: "🕊️",
//           title: "Justice & Peacebuilding",
//           description:
//             "CRS engages in justice and peacebuilding activity around the world by addressing the root causes of exclusion and inequity.",
//           stats: [
//             { value: "13M", label: "Participants" },
//             { value: "53", label: "Projects" },
//             { value: "41", label: "Countries" },
//           ],
//           link:"/news/jkliletry",
//         },
//         {
//           image: "https://picsum.photos/400/250?random=2",
//           icon: "👥",
//           title: "Local Leadership",
//           description:
//             "We help strengthen institutions so communities can lead their own development.",
//           stats: [
//             { value: "1.4M", label: "Participants" },
//             { value: "219", label: "Projects" },
//             { value: "64", label: "Countries" },
//           ],
//           link:"/news/jkliletry",
//         },
//         {
//           image: "https://picsum.photos/400/250?random=3",
//           icon: "💰",
//           title: "Microfinance",
//           description:
//             "We help poor communities create savings and lending groups to build financial resilience.",
//           stats: [
//             { value: "3M", label: "Participants" },
//             { value: "85", label: "Projects" },
//             { value: "45", label: "Countries" },
//           ],
//           link:"/news/jkliletry",
//         },
//         {
//             image: "https://picsum.photos/400/250?random=3",
//             icon: "💰",
//             title: "Microfinance",
//             description:
//               "We help poor communities create savings and lending groups to build financial resilience.",
//             stats: [
//               { value: "3M", label: "Participants" },
//               { value: "85", label: "Projects" },
//               { value: "45", label: "Countries" },
//             ],
//             link:"/news/jkliletry",
//           },
//           {
//             image: "https://picsum.photos/400/250?random=3",
//             icon: "💰",
//             title: "Microfinance",
//             description:
//               "We help poor communities create savings and lending groups to build financial resilience.",
//             stats: [
//               { value: "3M", label: "Participants" },
//               { value: "85", label: "Projects" },
//               { value: "45", label: "Countries" },
//             ],
//           },
//           {
//             image: "https://picsum.photos/400/250?random=3",
//             icon: "💰",
//             title: "Microfinance",
//             description:
//               "We help poor communities create savings and lending groups to build financial resilience.",
//             stats: [
//               { value: "3M", label: "Participants" },
//               { value: "85", label: "Projects" },
//               { value: "45", label: "Countries" },
//             ],
//           },
//       ];

//       const carouselRef = useRef(null);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   const handleScroll = () => {
//     const carousel = carouselRef.current;
//     if (carousel) {
//       const maxScroll = carousel.scrollWidth - carousel.clientWidth;
//       const progress = (carousel.scrollLeft / maxScroll) * 100;
//       setScrollProgress(progress);
//     }
//   };

//   const scrollNext = () => {
//     const carousel = carouselRef.current;
//     if (carousel) {
//       carousel.scrollBy({ left: 350, behavior: "smooth" });
//     }
//   };

//   const scrollPrev = () => {
//     const carousel = carouselRef.current;
//     if (carousel) {
//       carousel.scrollBy({ left: -350, behavior: "smooth" });
//     }
//   };

//   useEffect(() => {
//     const carousel = carouselRef.current;
//     if (carousel) {
//       carousel.addEventListener("scroll", handleScroll);
//       return () => carousel.removeEventListener("scroll", handleScroll);
//     }
//   }, []);


//   return (
//     <section className="news-news-carousel" >
//       <h2 className="section-title">Our Stories and Articles</h2>
//       <div className="news-carousel-container" ref={carouselRef}>
//         <div className="news-carousel-news">
//           {newsItems.map((item, index) => (
//             <article className="news-news-card" key={index}>
//               <div className="news-image-wrapper">
//                 <img src={item.image} alt={item.title} />
//                 <div className="news-icon">{item?.icon}</div>
//               </div>
//               <div className="news-content-news">
//                 <h3>{item.title}</h3>
//                 <p>{item.description}</p>
//                 <div className="news-stats">
//                   {/* {item.stats.map((s, i) => (
//                     <div className="news-stat-box" key={i}>
//                       <h4>{s.value}</h4>
//                       <p>{s.label}</p>
//                     </div>
//                   ))} */}
//                 </div>
//                 <a href={item?.link} className="news-learn-more">
//                   Learn More →
//                 </a>
//               </div>
//             </article>
//           ))}
//         </div>
//       </div>
//       {/* Carousel Controls */}
//       <div className="news-carousel-controls">
//         <button className="news-control-btn" onClick={scrollPrev}>
//           ◀ 
//         </button>

//         <button className="news-control-btn" onClick={scrollNext}>
//           ▶
//         </button>
//         <div className="news-progress-bar">
//           <div
//             className="news-progress-fill"
//             style={{ width: `${scrollProgress}%` }}
//           ></div>
//         </div>
//       </div>
//     </section>

//   )
// }

// export default ArticleStoriesSection